{
  "name": "blade-formatter",
  "engines": {
    "node": ">= 14.0.0"
  },
  "keywords": [
    "php",
    "formatter",
    "laravel"
  ],
  "version": "1.44.4",
  "description": "An opinionated blade template formatter for Laravel",
  "main": "./dist/bundle.cjs",
  "types": "./dist/types/main.d.ts",
  "type": "module",
  "exports": {
    ".": {
      "import": "./dist/bundle.js",
      "require": "./dist/bundle.cjs",
      "default": "./dist/bundle.js"
    },
    "./*": "./*"
  },
  "scripts": {
    "build": "cross-env NODE_ENV=production node esbuild.js && cross-env NODE_ENV=production ESM_BUILD=true node esbuild.js",
    "prepublish": "tsc src/main.ts --declaration --emitDeclarationOnly --outDir ./dist/types || true",
    "watch": "node esbuild.js",
    "test": "yarn run build && yarn run vitest run",
    "lint": "biome lint .",
    "fix": "biome lint . --fix",
    "format": "biome format . --write",
    "check_formatted": "biome format .",
    "changelog": "conventional-changelog -p angular -i CHANGELOG.md -s -r 0",
    "prepare": "husky install",
    "bin": "cross-env ./bin/blade-formatter.cjs"
  },
  "bin": {
    "blade-formatter": "bin/blade-formatter.cjs"
  },
  "author": "Shuhei Hayashibara",
  "license": "MIT",
  "dependencies": {
    "@prettier/plugin-php": "^0.24.0",
    "@shufo/tailwindcss-class-sorter": "3.0.1",
    "aigle": "^1.14.1",
    "ajv": "^8.9.0",
    "chalk": "^4.1.0",
    "concat-stream": "^2.0.0",
    "detect-indent": "^6.0.0",
    "find-config": "^1.0.0",
    "glob": "^13.0.0",
    "html-attribute-sorter": "^0.4.3",
    "ignore": "^6.0.0",
    "js-beautify": "^1.15.4",
    "lodash": "^4.17.19",
    "php-parser": "3.5.0",
    "prettier": "^3.2.5",
    "string-replace-async": "^2.0.0",
    "tailwindcss": "^3.1.8",
    "vscode-oniguruma": "1.7.0",
    "vscode-textmate": "^7.0.1",
    "xregexp": "^5.0.1",
    "yargs": "^17.3.1"
  },
  "devDependencies": {
    "@babel/core": "^7.6.4",
    "@babel/plugin-transform-modules-commonjs": "^7.16.5",
    "@babel/preset-env": "^7.13.12",
    "@babel/preset-typescript": "^7.16.5",
    "@biomejs/biome": "2.1.2",
    "@types/concat-stream": "^2.0.0",
    "@types/find-config": "^1.0.1",
    "@types/fs-extra": "^11.0.0",
    "@types/glob": "^8.0.0",
    "@types/js-beautify": "^1.13.3",
    "@types/lodash": "^4.14.178",
    "@types/mocha": "^10.0.0",
    "@types/node": "^24.0.0",
    "@types/xregexp": "^4.4.0",
    "app-root-path": "^3.0.0",
    "codecov": "^3.8.3",
    "cross-env": "^7.0.3",
    "esbuild": "^0.25.8",
    "esbuild-node-externals": "^1.16.0",
    "fs-extra": "^11.0.0",
    "husky": "^8.0.0",
    "lint-staged": ">=10",
    "source-map-loader": "^4.0.0",
    "ts-loader": "^9.2.6",
    "ts-migrate": "^0.1.27",
    "ts-node": "^10.4.0",
    "typescript": "^5.0.0",
    "vitest": "^4.0.0"
  },
  "repository": {
    "type": "git",
    "url": "https://github.com/shufo/blade-formatter.git"
  },
  "files": [
    "dist",
    "src",
    "bin",
    "wasm",
    "syntaxes",
    "CHANGELOG.md"
  ],
  "lint-staged": {
    "*.ts": "yarn run fix"
  }
}
